export default class Keys {
			static JWT_TOKEN = "BazarJwtToken";
			static REFRESH_TOKEN = "BazarRefreshToken";
			// static TOKEN_UPDATE = "shouldTokenUpdate";
}